import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { ProfileUser } from '../../Services/Operations/ProductAPI';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { logout } from "../../Store/authSlice";
import { toast } from "react-toastify";
const GOLD = "#e5932e";
const TAN = "#bba58b";
const WHITE = "#ffffff";
const DARK = "#1a1208";

const User = {
  id: 5,
  full_name: "Surajit Halder",
  email: "surajit11@gmail.com",
  phone: "7485691023",
  birth_date: "2000-06-07T00:00:00.000000Z",
  created_at: "2026-04-27T10:56:01.000000Z",
  profile_image: null,
};

const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
};

const getAge = (iso) => {
  const birth = new Date(iso);
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const m = now.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
  return age;
};

const getInitials = (name) =>
  name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2);

const memberSince = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { month: "long", year: "numeric" });
};

// Stat cards data
const stats = [
  { label: "Projects", value: "12", icon: "🏗️" },
  { label: "Completed", value: "9", icon: "✅" },
  { label: "Rating", value: "4.8", icon: "⭐" },
];


const Profile = () => {
      const { isAuthenticated ,token} = useSelector((state) => state.auth);
      const [user,setUser]=useState(User)
      const navigate=useNavigate()
      const dispatch=useDispatch()

    const handleGetUser=async()=>{
        try {
            const res= await ProfileUser(token)
            console.log(res);
            if(res.status===200){
                setUser(res.data.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }
    useEffect(() => {
     handleGetUser()
    }, [])

    const handleLogout=async()=>{dispatch(logout());
        toast.success("Loggedout successfully")
        navigate("/")}
    
   const [editMode, setEditMode] = useState(false);
   const [activeTab, setActiveTab] = useState("overview");
 
   return (
     <div style={{
       minHeight: "100vh",
       width: "100%",
       fontFamily: "'Cormorant Garamond', Georgia, serif",
       position: "relative",
       overflow: "hidden",
       background: `
         radial-gradient(ellipse at 75% 20%, rgba(229,147,46,0.14) 0%, transparent 55%),
         radial-gradient(ellipse at 15% 85%, rgba(187,165,139,0.18) 0%, transparent 50%),
         linear-gradient(135deg, #1a1208 0%, #2d1f0e 35%, #1c1407 70%, #0e0b05 100%)
       `,
     }}>
       <style>{`
         @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Josefin+Sans:wght@300;400;600&display=swap');
         * { box-sizing: border-box; margin: 0; padding: 0; }
 
         .back-btn:hover { background: rgba(229,147,46,0.15) !important; border-color: rgba(229,147,46,0.5) !important; color: #e5932e !important; }
         .edit-btn:hover { background: rgba(229,147,46,0.15) !important; border-color: rgba(229,147,46,0.5) !important; }
         .tab-btn:hover { color: rgba(255,255,255,0.8) !important; }
         .info-row:hover { background: rgba(229,147,46,0.06) !important; }
         .stat-card:hover { transform: translateY(-4px); border-color: rgba(229,147,46,0.35) !important; box-shadow: 0 16px 40px rgba(0,0,0,0.4), 0 0 0 1px rgba(229,147,46,0.15) !important; }
         .stat-card { transition: all 0.3s ease; }
 
         ::-webkit-scrollbar { width: 4px; }
         ::-webkit-scrollbar-track { background: transparent; }
         ::-webkit-scrollbar-thumb { background: rgba(187,165,139,0.3); border-radius: 2px; }
       `}</style>
 
       {/* BG grid */}
       <svg style={{ position:"absolute", inset:0, width:"100%", height:"100%", opacity:0.05, pointerEvents:"none" }} xmlns="http://www.w3.org/2000/svg">
         <defs>
           <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
             <path d="M 60 0 L 0 0 0 60" fill="none" stroke={TAN} strokeWidth="0.5"/>
           </pattern>
         </defs>
         <rect width="100%" height="100%" fill="url(#grid)"/>
       </svg>
 
       {/* Diagonal accent */}
       <div style={{
         position:"absolute", top:0, right:0,
         width:"40%", height:"100%",
         background:`linear-gradient(160deg, rgba(229,147,46,0.06) 0%, transparent 60%)`,
         borderLeft:`1px solid rgba(229,147,46,0.1)`,
         pointerEvents:"none",
       }}/>
 
       {/* Hero top bar */}
       <motion.div
         initial={{ opacity:0, y:-20 }}
         animate={{ opacity:1, y:0 }}
         transition={{ duration:0.6 }}
         style={{
           position:"relative", zIndex:20,
           display:"flex", alignItems:"center", justifyContent:"space-between",
           padding:"24px 32px 0",
         }}
       >
         {/* Back button */}
         <motion.button
           whileHover={{ scale:1.04 }}
           whileTap={{ scale:0.97 }}
           className="back-btn"
           onClick={() => window.history.back()}
           style={{
             display:"flex", alignItems:"center", gap:8,
             background:"rgba(187,165,139,0.08)",
             border:"1px solid rgba(187,165,139,0.2)",
             borderRadius:12, padding:"10px 18px",
             color:"rgba(255,255,255,0.7)",
             fontFamily:"'Josefin Sans', sans-serif",
             fontSize:11, fontWeight:600,
             letterSpacing:"0.14em", textTransform:"uppercase",
             cursor:"pointer", transition:"all 0.3s",
           }}
         >
           <span style={{ fontSize:14 }}>←</span> Back
         </motion.button>
 
         {/* Brand */}
         <div style={{ display:"flex", alignItems:"center", gap:10 }}>
           <div style={{
             width:32, height:32, borderRadius:9,
             background:`linear-gradient(135deg, ${GOLD}, #c97d22)`,
             display:"flex", alignItems:"center", justifyContent:"center",
             fontSize:16,
             boxShadow:`0 4px 12px rgba(229,147,46,0.35)`,
           }}>🏛️</div>
           <span style={{
             fontFamily:"'Cormorant Garamond', serif",
             fontSize:18, fontWeight:600, color:WHITE,
             letterSpacing:"0.04em",
           }}> Dhanushdhari Renovators</span>
         </div>
 
         {/* Edit button */}
         <motion.button
           whileHover={{ scale:1.04 }}
           whileTap={{ scale:0.97 }}
           className="edit-btn"
           onClick={() => handleLogout()}
           style={{
             display:"flex", alignItems:"center", gap:8,
             background: editMode ? "rgba(229,147,46,0.15)" : "rgba(187,165,139,0.08)",
             border: editMode ? "1px solid rgba(229,147,46,0.5)" : "1px solid rgba(187,165,139,0.2)",
             borderRadius:12, padding:"10px 18px",
             color: editMode ? GOLD : "rgba(255,255,255,0.7)",
             fontFamily:"'Josefin Sans', sans-serif",
             fontSize:11, fontWeight:600,
             letterSpacing:"0.14em", textTransform:"uppercase",
             cursor:"pointer", transition:"all 0.3s",
           }}
         >
          Logout
         </motion.button>
       </motion.div>
 
       {/* Main content */}
       <div style={{
         position:"relative", zIndex:10,
         maxWidth:820, margin:"0 auto",
         padding:"28px 24px 48px",
       }}>
 
         {/* ── HERO PROFILE CARD ── */}
         <motion.div
           initial={{ opacity:0, y:32, scale:0.97 }}
           animate={{ opacity:1, y:0, scale:1 }}
           transition={{ duration:0.7, ease:[0.22,1,0.36,1] }}
           style={{
             position:"relative",
             background:`linear-gradient(145deg, rgba(255,255,255,0.07) 0%, rgba(187,165,139,0.05) 100%)`,
             backdropFilter:"blur(24px)",
             border:`1px solid rgba(187,165,139,0.2)`,
             borderRadius:24, overflow:"hidden",
             marginBottom:20,
             boxShadow:`0 32px 64px rgba(0,0,0,0.55), 0 0 0 1px rgba(229,147,46,0.08), inset 0 1px 0 rgba(255,255,255,0.07)`,
           }}
         >
           {/* Gold top line */}
           <div style={{
             position:"absolute", top:0, left:"8%",
             width:"84%", height:2,
             background:`linear-gradient(90deg, transparent, ${GOLD}, transparent)`,
             borderRadius:2,
           }}/>
 
           {/* Cover strip */}
           <div style={{
             height:110,
             background:`linear-gradient(135deg, rgba(229,147,46,0.18) 0%, rgba(187,165,139,0.1) 50%, rgba(229,147,46,0.08) 100%)`,
             borderBottom:`1px solid rgba(229,147,46,0.12)`,
             position:"relative", overflow:"hidden",
           }}>
             {/* Decorative circles */}
             {[
               { size:140, x:"75%", y:"-30%", op:0.06 },
               { size:80, x:"85%", y:"60%", op:0.08 },
               { size:200, x:"-5%", y:"-50%", op:0.04 },
             ].map((c,i) => (
               <div key={i} style={{
                 position:"absolute", left:c.x, top:c.y,
                 width:c.size, height:c.size, borderRadius:"50%",
                 border:`1px solid rgba(229,147,46,${c.op * 5})`,
                 background:`radial-gradient(circle, rgba(229,147,46,${c.op}) 0%, transparent 70%)`,
               }}/>
             ))}
             <div style={{
               position:"absolute", bottom:0, left:0, right:0,
               padding:"0 32px 0",
               fontFamily:"'Josefin Sans', sans-serif",
               fontSize:9, color:`rgba(187,165,139,0.4)`,
               letterSpacing:"0.3em", textTransform:"uppercase",
               display:"flex", alignItems:"flex-end", height:"100%", paddingBottom:12,
             }}>
               Premium Member · ID #{user.id.toString().padStart(4,"0")}
             </div>
           </div>
 
           {/* Avatar + name row */}
           <div style={{ padding:"0 32px 32px", position:"relative" }}>
             <div style={{ display:"flex", alignItems:"flex-end", gap:20, marginTop:-38, marginBottom:20 }}>
               {/* Avatar */}
               <motion.div
                 initial={{ scale:0.7, opacity:0 }}
                 animate={{ scale:1, opacity:1 }}
                 transition={{ duration:0.5, delay:0.3 }}
                 style={{ position:"relative", flexShrink:0 }}
               >
                 <div style={{
                   width:88, height:88, borderRadius:22,
                   background:`linear-gradient(135deg, ${GOLD} 0%, #c97d22 60%, #a86a1a 100%)`,
                   display:"flex", alignItems:"center", justifyContent:"center",
                   fontSize:30, fontWeight:700,
                   color:DARK,
                   fontFamily:"'Josefin Sans', sans-serif",
                   border:`3px solid rgba(229,147,46,0.5)`,
                   boxShadow:`0 12px 32px rgba(229,147,46,0.4), 0 0 0 6px rgba(229,147,46,0.08)`,
                 }}>
                   {getInitials(user.full_name)}
                 </div>
                 {/* Online dot */}
                 <div style={{
                   position:"absolute", bottom:4, right:4,
                   width:14, height:14, borderRadius:"50%",
                   background:"#4ade80",
                   border:`2px solid ${DARK}`,
                   boxShadow:"0 0 8px rgba(74,222,128,0.6)",
                 }}/>
               </motion.div>
 
               {/* Name + role */}
               <motion.div
                 initial={{ opacity:0, x:-16 }}
                 animate={{ opacity:1, x:0 }}
                 transition={{ duration:0.5, delay:0.4 }}
                 style={{ paddingBottom:4, flex:1 }}
               >
                 <h1 style={{
                   fontFamily:"'Cormorant Garamond', serif",
                   fontSize:28, fontWeight:600,
                   color:WHITE, letterSpacing:"0.02em",
                   lineHeight:1.1, marginBottom:6,
                 }}>
                   {user.full_name}
                 </h1>
                 <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
                   <span style={{
                     fontFamily:"'Josefin Sans', sans-serif",
                     fontSize:10, fontWeight:600,
                     color:GOLD, letterSpacing:"0.18em",
                     textTransform:"uppercase",
                     background:"rgba(229,147,46,0.12)",
                     border:"1px solid rgba(229,147,46,0.25)",
                     borderRadius:6, padding:"3px 10px",
                   }}>
                     ✦ Premium Client
                   </span>
                   <span style={{
                     fontFamily:"'Josefin Sans', sans-serif",
                     fontSize:10, color:"rgba(187,165,139,0.6)",
                     letterSpacing:"0.1em",
                   }}>
                     Member since {memberSince(user.created_at)}
                   </span>
                 </div>
               </motion.div>
 
               {/* Stat mini-badges */}
               <motion.div
                 initial={{ opacity:0 }}
                 animate={{ opacity:1 }}
                 transition={{ delay:0.55 }}
                 style={{ display:"flex", gap:8, paddingBottom:4 }}
               >
                 {stats.map((s, i) => (
                   <motion.div
                     key={s.label}
                     className="stat-card"
                     initial={{ opacity:0, y:10 }}
                     animate={{ opacity:1, y:0 }}
                     transition={{ delay:0.5 + i*0.1 }}
                     style={{
                       textAlign:"center",
                       background:"rgba(187,165,139,0.07)",
                       border:"1px solid rgba(187,165,139,0.18)",
                       borderRadius:14, padding:"12px 16px",
                       minWidth:72,
                       boxShadow:"0 8px 24px rgba(0,0,0,0.3)",
                       cursor:"default",
                     }}
                   >
                     <div style={{ fontSize:18, marginBottom:4 }}>{s.icon}</div>
                     <div style={{
                       fontFamily:"'Cormorant Garamond', serif",
                       fontSize:22, fontWeight:600, color:WHITE,
                       lineHeight:1,
                     }}>{s.value}</div>
                     <div style={{
                       fontFamily:"'Josefin Sans', sans-serif",
                       fontSize:9, color:TAN,
                       letterSpacing:"0.12em", textTransform:"uppercase",
                       marginTop:4,
                     }}>{s.label}</div>
                   </motion.div>
                 ))}
               </motion.div>
             </div>
 
             {/* Divider */}
             <div style={{ height:1, background:"rgba(187,165,139,0.1)", marginBottom:0 }}/>
           </div>
         </motion.div>
 
         {/* ── TABS ── */}
         <motion.div
           initial={{ opacity:0, y:16 }}
           animate={{ opacity:1, y:0 }}
           transition={{ delay:0.45 }}
           style={{ display:"flex", gap:4, marginBottom:20 }}
         >
           {[
             { key:"overview", label:"Overview", icon:"◈" },
             { key:"activity", label:"Activity", icon:"◉" },
           ].map(tab => (
             <button
               key={tab.key}
               className="tab-btn"
               onClick={() => setActiveTab(tab.key)}
               style={{
                 fontFamily:"'Josefin Sans', sans-serif",
                 fontSize:11, fontWeight:600,
                 letterSpacing:"0.15em", textTransform:"uppercase",
                 padding:"10px 20px",
                 background: activeTab===tab.key ? "rgba(229,147,46,0.12)" : "transparent",
                 border: activeTab===tab.key ? "1px solid rgba(229,147,46,0.3)" : "1px solid transparent",
                 borderRadius:10,
                 color: activeTab===tab.key ? GOLD : "rgba(187,165,139,0.5)",
                 cursor:"pointer", transition:"all 0.3s",
                 display:"flex", alignItems:"center", gap:7,
               }}
             >
               <span style={{ fontSize:12 }}>{tab.icon}</span>
               {tab.label}
             </button>
           ))}
         </motion.div>
 
         <AnimatePresence mode="wait">
           {activeTab === "overview" && (
             <motion.div
               key="overview"
               initial={{ opacity:0, y:16 }}
               animate={{ opacity:1, y:0 }}
               exit={{ opacity:0, y:-10 }}
               transition={{ duration:0.4 }}
             >
               {/* Two-col layout */}
               <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
 
                 {/* ── Personal Info card ── */}
                 <InfoCard
                   title="Personal Information"
                   icon="👤"
                   delay={0.5}
                   style={{ gridColumn:"1 / -1" }}
                 >
                   <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:0 }}>
                     {[
                       { label:"Full Name", value:user.full_name, icon:"✦" },
                       { label:"Email Address", value:user.email, icon:"✉" },
                       { label:"Phone Number", value:user.phone, icon:"☏" },
                       { label:"Date of Birth", value:formatDate(user.birth_date), icon:"◈" },
                       { label:"Age", value:`${getAge(user.birth_date)} years`, icon:"◉" },
                       { label:"Member ID", value:`#${user.id.toString().padStart(4,"0")}`, icon:"⬡" },
                     ].map((row, i) => (
                       <InfoRow key={row.label} {...row} index={i} />
                     ))}
                   </div>
                 </InfoCard>
 
                 {/* ── Account Details card ── */}
                 <InfoCard title="Account Details" icon="🔐" delay={0.6}>
                   {[
                     { label:"Account Status", value:"Active", icon:"◉", highlight:true },
                     { label:"Member Since", value:memberSince(user.created_at), icon:"◈" },
                     { label:"Last Updated", value:formatDate(user.created_at), icon:"✦" },
                     { label:"Profile Image", value:"Not uploaded", icon:"◫" },
                   ].map((row, i) => (
                     <InfoRow key={row.label} {...row} index={i} />
                   ))}
                 </InfoCard>
 
                 {/* ── Membership card ── */}
                 <InfoCard title="Membership" icon="⭐" delay={0.65}>
                   <div style={{ padding:"8px 0" }}>
                     <div style={{
                       background:`linear-gradient(135deg, rgba(229,147,46,0.12) 0%, rgba(187,165,139,0.06) 100%)`,
                       border:`1px solid rgba(229,147,46,0.2)`,
                       borderRadius:14, padding:"20px",
                       marginBottom:16,
                       position:"relative", overflow:"hidden",
                     }}>
                       <div style={{
                         position:"absolute", top:-20, right:-20,
                         width:80, height:80, borderRadius:"50%",
                         background:"rgba(229,147,46,0.08)",
                         border:"1px solid rgba(229,147,46,0.15)",
                       }}/>
                       <div style={{
                         fontFamily:"'Josefin Sans', sans-serif",
                         fontSize:9, color:GOLD,
                         letterSpacing:"0.2em", textTransform:"uppercase",
                         marginBottom:8,
                       }}>Current Plan</div>
                       <div style={{
                         fontFamily:"'Cormorant Garamond', serif",
                         fontSize:24, fontWeight:600, color:WHITE,
                         marginBottom:4,
                       }}>Premium</div>
                       <div style={{
                         fontFamily:"'Josefin Sans', sans-serif",
                         fontSize:10, color:`rgba(187,165,139,0.6)`,
                         letterSpacing:"0.08em",
                       }}>Full access to all renovation services</div>
                     </div>
 
                     {/* Progress bar */}
                     <div style={{ marginBottom:6 }}>
                       <div style={{ display:"flex", justifyContent:"space-between", marginBottom:8 }}>
                         <span style={{ fontFamily:"'Josefin Sans', sans-serif", fontSize:10, color:TAN, letterSpacing:"0.1em", textTransform:"uppercase" }}>Projects Used</span>
                         <span style={{ fontFamily:"'Josefin Sans', sans-serif", fontSize:10, color:GOLD, fontWeight:600 }}>9 / 12</span>
                       </div>
                       <div style={{ height:4, background:"rgba(187,165,139,0.15)", borderRadius:4 }}>
                         <motion.div
                           initial={{ width:0 }}
                           animate={{ width:"75%" }}
                           transition={{ duration:1, delay:0.9, ease:"easeOut" }}
                           style={{
                             height:"100%", borderRadius:4,
                             background:`linear-gradient(90deg, ${GOLD}, #f0a84a)`,
                             boxShadow:`0 0 8px rgba(229,147,46,0.5)`,
                           }}
                         />
                       </div>
                     </div>
                   </div>
                 </InfoCard>
 
               </div>
             </motion.div>
           )}
 
           {activeTab === "activity" && (
             <motion.div
               key="activity"
               initial={{ opacity:0, y:16 }}
               animate={{ opacity:1, y:0 }}
               exit={{ opacity:0, y:-10 }}
               transition={{ duration:0.4 }}
             >
               <InfoCard title="Recent Activity" icon="📋" delay={0.3}>
                 {[
                   { action:"Account Created", detail:"Profile successfully registered", time:"Just now", icon:"🎉" },
                   { action:"Profile Viewed", detail:"Overview section accessed", time:"Today", icon:"👁️" },
                   { action:"Plan Activated", detail:"Premium membership activated", time:"Today", icon:"⭐" },
                 ].map((item, i) => (
                   <motion.div
                     key={i}
                     initial={{ opacity:0, x:-12 }}
                     animate={{ opacity:1, x:0 }}
                     transition={{ delay:0.35 + i * 0.1 }}
                     style={{
                       display:"flex", alignItems:"flex-start", gap:16,
                       padding:"16px 0",
                       borderBottom: i < 2 ? "1px solid rgba(187,165,139,0.08)" : "none",
                     }}
                   >
                     <div style={{
                       width:38, height:38, borderRadius:10, flexShrink:0,
                       background:"rgba(229,147,46,0.1)",
                       border:"1px solid rgba(229,147,46,0.2)",
                       display:"flex", alignItems:"center", justifyContent:"center",
                       fontSize:16,
                     }}>{item.icon}</div>
                     <div style={{ flex:1 }}>
                       <div style={{ fontFamily:"'Josefin Sans', sans-serif", fontSize:12, fontWeight:600, color:WHITE, letterSpacing:"0.06em", marginBottom:4 }}>{item.action}</div>
                       <div style={{ fontFamily:"'Josefin Sans', sans-serif", fontSize:11, color:"rgba(187,165,139,0.6)", letterSpacing:"0.04em" }}>{item.detail}</div>
                     </div>
                     <div style={{ fontFamily:"'Josefin Sans', sans-serif", fontSize:10, color:"rgba(187,165,139,0.4)", letterSpacing:"0.08em", textTransform:"uppercase", flexShrink:0, paddingTop:2 }}>{item.time}</div>
                   </motion.div>
                 ))}
               </InfoCard>
             </motion.div>
           )}
         </AnimatePresence>
       </div>
 
       {/* Bottom brand */}
       <motion.div
         initial={{ opacity:0 }}
         animate={{ opacity:0.3 }}
         transition={{ delay:1.2 }}
         style={{
           position:"fixed", bottom:16, left:"50%",
           transform:"translateX(-50%)",
           fontFamily:"'Josefin Sans', sans-serif",
           fontSize:9, color:TAN,
           letterSpacing:"0.22em", textTransform:"uppercase",
           whiteSpace:"nowrap", zIndex:10,
           pointerEvents:"none",
         }}
       >
         © 2026 RenovaSpace · Premium Renovation Studio
       </motion.div>
     </div>
   );
 }
 
 // ── Reusable InfoCard ──
 function InfoCard({ title, icon, children, delay=0.5, style={} }) {
   return (
     <motion.div
       initial={{ opacity:0, y:20 }}
       animate={{ opacity:1, y:0 }}
       transition={{ duration:0.5, delay }}
       style={{
         background:`linear-gradient(145deg, rgba(255,255,255,0.05) 0%, rgba(187,165,139,0.04) 100%)`,
         backdropFilter:"blur(20px)",
         border:`1px solid rgba(187,165,139,0.18)`,
         borderRadius:20,
         padding:"24px 28px",
         boxShadow:`0 20px 48px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.05)`,
         position:"relative", overflow:"hidden",
         ...style,
       }}
     >
       {/* Corner accent */}
       <div style={{
         position:"absolute", top:0, right:0,
         width:60, height:60,
         background:"radial-gradient(circle at top right, rgba(229,147,46,0.08), transparent 70%)",
         borderRadius:"0 20px 0 0",
       }}/>
 
       {/* Card header */}
       <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20 }}>
         <div style={{
           width:32, height:32, borderRadius:9,
           background:"rgba(229,147,46,0.12)",
           border:"1px solid rgba(229,147,46,0.22)",
           display:"flex", alignItems:"center", justifyContent:"center",
           fontSize:15,
         }}>{icon}</div>
         <div>
           <h3 style={{
             fontFamily:"'Josefin Sans', sans-serif",
             fontSize:11, fontWeight:600,
             color:WHITE, letterSpacing:"0.16em",
             textTransform:"uppercase",
           }}>{title}</h3>
         </div>
         <div style={{ flex:1, height:1, background:"rgba(187,165,139,0.1)", marginLeft:8 }}/>
       </div>
 
       {children}
     </motion.div>
   );
 }
 
 // ── Reusable InfoRow ──
 function InfoRow({ label, value, icon, highlight=false, index=0 }) {
   return (
     <motion.div
       className="info-row"
       initial={{ opacity:0, x:-8 }}
       animate={{ opacity:1, x:0 }}
       transition={{ delay:0.55 + index*0.06 }}
       style={{
         display:"flex", alignItems:"center", gap:14,
         padding:"13px 12px",
         borderBottom:"1px solid rgba(187,165,139,0.07)",
         borderRadius:8,
         transition:"background 0.2s",
         cursor:"default",
       }}
     >
       <span style={{
         fontFamily:"'Cormorant Garamond', serif",
         fontSize:14, color:`rgba(229,147,46,0.5)`,
         width:16, textAlign:"center", flexShrink:0,
       }}>{icon}</span>
       <div style={{ flex:1 }}>
         <div style={{
           fontFamily:"'Josefin Sans', sans-serif",
           fontSize:9, fontWeight:600,
           color:"rgba(187,165,139,0.45)",
           letterSpacing:"0.16em", textTransform:"uppercase",
           marginBottom:3,
         }}>{label}</div>
         <div style={{
           fontFamily:"'Josefin Sans', sans-serif",
           fontSize:13, fontWeight:400,
           color: highlight ? "#4ade80" : "rgba(255,255,255,0.85)",
           letterSpacing:"0.03em",
         }}>
           {highlight && <span style={{ marginRight:6, fontSize:11 }}>●</span>}
           {value}
         </div>
       </div>
     </motion.div>
   );
}

export default Profile
